import React, { useState } from 'react';
import { Send } from 'lucide-react';
import PrimaryButton from '../components/PrimaryButton';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Store in localStorage for now
    const existingSubmissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
    existingSubmissions.push({ ...formData, date: new Date().toISOString() });
    localStorage.setItem('contactSubmissions', JSON.stringify(existingSubmissions));
    
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
    
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Contact Us</h1>
        <p className="body-large page-subtitle">
          Have questions? Want to discuss theology or apologetics? Reach out to us.
        </p>

        <div className="contact-content">
          <div className="contact-info">
            <h2 className="heading-2">Get In Touch</h2>
            <p className="body-large">
              We welcome thoughtful questions, debate invitations, and theological discussions. 
              Please use the form to contact us.
            </p>
            
            <div className="contact-details">
              <div className="contact-detail-item">
                <h3 className="heading-3">Email</h3>
                <p className="body-medium">contact@praiseiam.org</p>
              </div>
              
              <div className="contact-detail-item">
                <h3 className="heading-3">YouTube</h3>
                <p className="body-medium">@PraiseIAMApologetics</p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            {submitted && (
              <div className="form-success">
                <p className="body-large">Thank you! Your message has been received.</p>
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="form-textarea"
                />
              </div>

              <PrimaryButton type="submit" icon={Send}>
                Send Message
              </PrimaryButton>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
